<template>
  <b-modal size="lg"
           v-model="isModal"
           no-close-on-backdrop
           no-close-on-esc
           hide-header
           hide-footer>
    <div class="modal-header">
      <h5 class="modal-title">외부뉴스 조회</h5>
      <button type="button" class="close" @click="closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" style="height: 600px; overflow-x: none; overflow-y: auto;">
      <!-- 모달 내용 -->
      <b-row class="pt-sm-1">
        <b-col sm="12">
          <table class="table table-bordered oddBackground">
            <tbody>
            <tr>
              <td style="width: 20%;">메뉴 대분류</td>
              <td style="width: 30%;" class="tl">
                <b-form-select id=""
                               name=""
                               style="width:100%; padding:0px 10px"
                               v-model="selectedMainMenuCode"
                               :plain="true"
                               @change="getMainMenuList()"
                               refs="mainSelect"
                >
                  <option disabled value="null">메뉴를 선택해 주세요</option>
                  <option :value="cItems.item_code"
                          v-for="(cItems, idx) in mainMenu">{{cItems.item_name}}
                  </option>
                </b-form-select>
              </td>
              <td style="width: 20%;">메뉴 소분류</td>
              <td style="width: 30%;" class="tl">
                <b-form-select id=""
                               name=""
                               style="width:100%; padding:0px 10px"
                               :plain="true"
                               v-model="selectedMainSubMenuCode"
                               @change="selectSubMenuCode()"
                >
                  <option disabled value="null">메뉴를 선택해 주세요</option>
                  <option :value="cItems.item_code"
                          v-for="(cItems, idx) in subMenu">{{cItems.item_name}}</option>
                </b-form-select>
              </td>
            </tr>
            <tr>
              <td style="width: 20%;">사이트</td>
              <td style="width: 30%;" class="tl">{{ item.site_name }}</td>
              <td style="width: 20%;">사용유무</td>
              <td style="width: 30%;" class="tl">{{ item.use_yn }}</td>
            </tr>
            <tr>
              <td>제목</td>
              <td class="tl" colspan="3">{{ item.title }}</td>
            </tr>
            <tr>
              <td>사이트 상세</td>
              <td class="tl">
                <button v-if="item.detail_link !== null && item.detail_link !== ''" class="btn btn-outline-primary btn-sm" @click="externalPageGo(item.detail_link)">이동하기</button>
              </td>
              <td>저자</td>
              <td class="tl">{{ item.author }}</td>
            </tr>
            <tr>
              <td>게시일</td>
              <td class="tl">{{ item.posting_date }}</td>
              <td>조회수</td>
              <td class="tl">{{ item.view_cnt | numberComma }}</td>
            </tr>
            <tr>
              <td>관심카테고리 설정</td>
              <td class="tl" colspan="3">
                <div v-if="!isInterest" style="width: 88%; float: left;">
                  <template v-for="cate in item.cate_name_list">
                    <div class="badge badge-primary" style="font-size:14px; margin: 3px 3px 3px 3px; font-weight: 200;">{{ cate }}</div>
                  </template>
                </div>
                <div v-if="!isInterest" style="width: 12%; float: left;">
                  <button class="btn btn-outline-primary" style="margin-right: 5px;" @click="isInterest = !isInterest">수정</button>
                </div>

                <div v-if="isInterest" style="width: 75%; float: left;">
                  <b-form-checkbox-group v-model="item.cate_list">
                    <template v-for="(data, index) in interestList">
                      <b-form-checkbox :value="data.item_code">{{data.item_name}}</b-form-checkbox>
                    </template>
                  </b-form-checkbox-group>
                </div>
                <div v-if="isInterest" style="width: 25%; float: left; margin-top: 10px; padding-left: 20px;">
                  <button class="btn btn-outline-primary" @click="saveInterest">저장</button>
                  <button class="btn btn-outline-danger" @click="isInterest = !isInterest">취소</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>해시태그</td>
              <td class="tl" colspan="3">
                <template v-for="tag in splitHashTag">
                  <div class="badge badge-danger" style="font-size:14px; margin: 3px 3px 3px 3px; font-weight: 200;">{{ tag }}</div>
                </template>
              </td>
            </tr>
            <tr>
              <td>관리자 지정<br/>해시태그</td>
              <td class="tl" colspan="3">
                <div style="width: 88%; float: left;">
                  <template v-if="!isCustomHashTag" v-for="tag in splitCustomHashTag">
                    <div class="badge badge-danger" style="font-size:14px; margin: 3px 3px 3px 3px; font-weight: 200;">{{ tag }}</div>
                  </template>
                </div>
                <div style="width: 12%; float: left;">
                  <button v-if="!isCustomHashTag" class="btn btn-outline-primary" style="margin-right: 5px;" @click="isCustomHashTag = !isCustomHashTag">수정</button>
                </div>

                <template v-if="isCustomHashTag">
                  <div style="width: 70%; float: left;">
                                                <textarea style="width:100%;height:50px;"
                                                          v-model="item.custom_hash_tag"
                                                          placeholder="해시태그는 콤마(,) 으로 공백없이 작성해주세요."
                                                ></textarea>
                  </div>
                  <div style="width: 30%; float: left; margin-top: 10px; padding-left: 20px;">
                    <button class="btn btn-outline-primary" @click="saveCustomHashTag">저장</button>
                    <button class="btn btn-outline-danger" @click="isCustomHashTag = !isCustomHashTag">취소</button>
                  </div>
                </template>
              </td>
            </tr>
            <tr>
              <td>내용</td>
              <td class="tl" colspan="3">{{ item.description }}</td>
            </tr>
            <tr>
              <td>썸네일 이미지</td>
              <td class="tl" colspan="3">
                <img :src="item.img_url"/>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" @click="modifyMenu">메뉴 수정</button>
      <button class="btn btn-primary" @click="closeModal">확인</button>
    </div>
  </b-modal>
</template>
<script>
import swal from 'sweetalert2'
import { EventBus } from "../../../event-bus";
import { codeAPI } from '../../../../common/code.js';

export default {
  name: "extNewsDetailModal",
  props: {
    formModal: {
      type: Boolean,
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      isModal: false,
      isCustomHashTag : false,
      isInterest: false,
      interestList: [],
      selectedMainMenuCode : null,
      selectedMainSubMenuCode : '',
      type_code : '',
      mainMenu : [],
      subMenu : [],
    }
  },
  created() {
    codeAPI.selectItemCodeList(this,"RPT_TYPE",2,"mainMenu");
    codeAPI.selectItemCodeList(this,"RPT_TYPE",2,"minorMenu");
  },
  mounted() {
    this.findCodesList();
  },
  computed: {
    splitHashTag(){
      let datas = [];
      if(this.item.hash_tag) datas = this.item.hash_tag.split(/[,\s]+/);
      return datas;
    },
    splitCustomHashTag(){
      let datas = [];
      if(this.item.custom_hash_tag) datas = this.item.custom_hash_tag.split(/[,\s]+/);
      return datas;
    },
    sortedInterestList() {
      // 배열을 정렬하여 새로운 배열을 반환
      return this.interestList.sort((a, b) => a.item_seq < b.item_seq);
    }
  },
  methods: {
    modifyMenu() {
      if(this.type_code === null || this.type_code === ''){
        swal.fire({
          type: 'warning',
          title: '메뉴를 선택하여주세요.',
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        swal.fire({
          title: '메뉴 지정',
          text: "해당 메뉴를 저장 하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            var token = sessionStorage.getItem("myToken");

            this.item.type_code = this.type_code;

            var param = encodeURI(JSON.stringify(this.item));
            var data = new FormData();
            data.append('objs', param);

            this.$http.post('/api/update/updateNewsMenu?access_token='+token, data, null)
              .then((result) => {
                const { data } = result;
                if(data === 'ok'){
                  EventBus.$emit('findExtNewsPage');
                  EventBus.$emit('callExtNewsDetailCloseModal');
                }else{
                  swal.fire({
                    type: 'error',
                    title: '저장 중 오류가 발생하였습니다.',
                    showConfirmButton: false,
                    timer: 1500
                  })
                }
              });
          }
        });
      }
    },
    getMainMenuList(){
      codeAPI.selectItemCodeList(this, this.selectedMainMenuCode, 3, "subMenu");
    },
    selectSubMenuCode(){
      this.type_code = this.selectedMainSubMenuCode;
    },
    // 관심카테고리 목록
    findCodesList() {
      var token = sessionStorage.getItem("myToken");
      // INTEREST_FIELD_CODE(관심분야)
      this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=INTEREST_FIELD_CODE')
        .then((result) => {
          const { data } = result;
          this.interestList = data;
        })
    },
    closeModal(){
      EventBus.$emit('callExtNewsDetailCloseModal');
    },
    externalPageGo(url){
      window.open(url, '_blank');
    },
    saveInterest() {
      swal.fire({
        title: '관심카테고리 설정',
        text: "저장 하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          var param = encodeURI(JSON.stringify(this.item));
          var data = new FormData();
          data.append('objs', param);

          this.$http.post('/api/update/updateNewsInterest?access_token='+token, data, null)
            .then((result) => {
              const { data } = result;
              if(data === 'ok'){
                this.isInterest = false;

                this.item.cate_name_list = [];
                this.interestList.forEach((value1, index1) => {
                  this.item.cate_list.forEach((value2, index2) => {
                    if(value1.item_code === value2){
                      this.item.cate_name_list.push(value1.item_name);
                    }
                  });
                });
              }else{
                swal.fire({
                  type: 'error',
                  title: '저장 중 오류가 발생하였습니다.',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            });
        }
      });
    },
    saveCustomHashTag(){
      this.item.custom_hash_tag = this.item.custom_hash_tag.replace(/\s/g, '');

      let lastIndex = this.item.custom_hash_tag.lastIndexOf(',');
      let tagLenth = this.item.custom_hash_tag.length - 1;

      // 마지막 콤마 제거
      const lastCommaRegx = /,\s*$/;
      while(lastIndex === tagLenth){
        this.item.custom_hash_tag = this.item.custom_hash_tag.replace(lastCommaRegx, '');
        lastIndex = this.item.custom_hash_tag.lastIndexOf(',');
        tagLenth = this.item.custom_hash_tag.length - 1;
        if(this.item.custom_hash_tag === '') break;
      }
      /*
      if(this.item.custom_hash_tag === ''){
          swal.fire({
              type: 'warning',
              title: '관리자 지정 해시태그를 입력하여주세요.',
              showConfirmButton: false,
              timer: 1500
          })
      }else{
      */
      swal.fire({
        title: '관리자 지정 해시태그',
        text: "저장 하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          var param = encodeURI(JSON.stringify(this.item));
          var data = new FormData();
          data.append('objs', param);

          this.$http.post('/api/update/updateNewsCustomHashTag?access_token='+token, data, null)
            .then((result) => {
              const { data } = result;
              if(data === 'ok'){
                this.isCustomHashTag = false;
              }else{
                swal.fire({
                  type: 'error',
                  title: '저장 중 오류가 발생하였습니다.',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            });
        }
      });

      // }
    }
  },
  watch: {
    formModal: function (value, oldValue) {
      this.isModal=  this.formModal;
      if(!this.isModal) {
        this.isCustomHashTag = false;
        this.isInterest = false;
      }
    },
    item: function (value, oldValue) {
      console.log(this.item.type_parent_code, this.item.type_code);
      this.selectedMainMenuCode = this.item.type_parent_code;
      this.getMainMenuList();
      this.selectedMainSubMenuCode = this.item.type_code;
    }
  },
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
.tl {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/extNews/component/ExtNewsDetailModal.vue